import styled from "styled-components";

export const FooterContainer = styled.div`
    padding-top: 30px;
    padding-bottom: 15px;
    background: linear-gradient(#150b1f, #000);
`

export const FooterWrapper = styled.div`
    max-width: 900px;
`

export const FooterH2 = styled.h2`
    font-size: 1.3rem;
    color: white;
    font-weight: 500;
    margin-bottom: 30px;
`

export const FooterLink = styled.a`
    font-size: 0.9rem;
    text-decoration: none;
    color: white;
    display: flex;
    transition: all 0.3s;

    &:hover {
        color: #B05FFD;
    }
`

export const SocialIconsWrapper = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
`

export const SocialIcon = styled.a`
    color: white;
    font-size: 1.5rem;
    transition: all 0.3s;

    &:hover {
        color: #B05FFD;
        transform: scale(1.1);
    }
`

export const FooterBottom = styled.div`
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 20px;
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 20px;

    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 15px;
    }
`

export const CopyrightText = styled.p`
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.85rem;
    margin: 0;
`

export const FooterBottomLink = styled.a`
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.85rem;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
        color: #B05FFD;
    }
`